import {Request} from '@/apis'

export function upload(file) {
    let form = new FormData();
    form.append("file", file);
    return Request.upload("/file", form);
}
